module.exports = __webpack_public_path__ + "static/media/Graphik-Regular.e2a1876e.otf";